import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Home from './pages/Home/Home';
import Showcase from './pages/Showcase/Showcase';
import Cnc from './pages/Cnc/Cnc';
import GlassSeals from './pages/GlassSeals/GlassSeals';
import About from './pages/About/About';
import Equipment from './pages/Equipment/Equipment';
import Materials from './pages/Materials/Materials';
import Workflow from './pages/Workflow/Workflow';
import Contact from './pages/Contact/Contact';
import Privacy from './pages/Privacy';
import NotFound from './pages/NotFound';

export default class Routes extends React.Component {
  render() {
    return (
      <Switch>
        <Route
          title="Accratronics Seals, LLC."
          exact
          path="/"
          render={props => <Home {...this.props} />}
        />
        <Route
          title="Showcase"
          path="/showcase"
          render={props => <Showcase {...this.props} />}
        />
        <Route
          title="CNC Machining"
          path="/cnc"
          render={props => <Cnc {...this.props} />}
        />
        <Route
          title="Glass Seals"
          path="/glass-seals"
          render={props => <GlassSeals {...this.props} />}
        />
        <Route
          title="About"
          path="/about"
          render={props => <About {...this.props} />}
        />
        <Route
          title="Equipment"
          path="/equipment"
          render={props => <Equipment {...this.props} />}
        />
        <Route
          title="Materials"
          path="/materials"
          render={props => <Materials {...this.props} />}
        />
        <Route
          title="Workflow"
          path="/workflow"
          render={props => <Workflow {...this.props} />}
        />
        <Route
          title="Contact"
          path="/contact"
          render={props => <Contact {...this.props} />}
        />
        <Route
          title="Privacy Policy"
          path="/privacy"
          render={props => <Privacy {...this.props} />}
        />
        <Route path="*" render={props => <NotFound {...this.props} />} />
      </Switch>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Routes.js